import React from "react";
import Swal from "sweetalert2";
import {
  cancelMembershipForUser,
  deleteUser,
  updateMembershipCancellationActiveReminderAdminCall,
  updateUser,
  whitelistUser,
} from "../../../../Api/ApiCalls";
import { toast } from "react-toastify";
import { toastOptions } from "../../../../config/Constants";

const Modal = ({
  id,
  ModalTitle,
  ModalBody,
  ModalTrigger,
  Theme,
  userData,
  endpoint,
  cancelationData,
  disabled,
  modifiedData,
  onlyOneButton = false,
  withHeader = true,
  contentWidth,
                 setUserData
}) => {

  const getButtonConfig = () => {
    switch (Theme) {
      case "KWM":
        return {
          cancelButton: {
            style: "btn btn-secondary",
            text: "End KWM for user",
          },
          saveButton: { style: "btn btn-warning", text: "Close" },
        };
      case "cancel-sub":
        return {
          cancelButton: {
            style: "btn btn-danger",
            text: "Cancel subscription",
          },
          saveButton: { style: "btn btn-warning", text: "Close" },
        };
      case "erase-user":
        return {
          cancelButton: { style: "btn btn-secondary", text: "Erase User" },
          saveButton: { style: "btn btn-warning", text: "Close" },
        };
      case "update_user":
        return {
          saveButton: { style: "btn btn-secondary", text: "Close" },
          cancelButton: { style: "btn btn-warning", text: "Update" },
        };
      case "whitelist_user":
        return {
          saveButton: { style: "btn btn-warning", text: "Close" },
          cancelButton: { style: "btn btn-secondary", text: "Whitelist user" },
        };
      case "not_whitelist_user":
        return {
          saveButton: { style: "btn btn-warning", text: "Close" },
        };
      case "mandate_number":
        return {
          saveButton: { style: "btn btn-danger", text: "Close" },
        };
      default:
        return {
          cancelButton: { style: "btn btn-secondary", text: "Close" },
          saveButton: { style: "btn btn-warning", text: "Save changes" },
        };
    }
  };

  const buttonConfig = getButtonConfig();

  const handleSubmit = async () => {
    startLoading();
    switch (endpoint) {
      case "unsubscribe_member_admin":
        if(disabled || !cancelationData.date)
          return;
        await cancelMembershipForUser({
          email: userData.email,
          no_payment_link: cancelationData.checked,
          expiration_date: new Date(cancelationData.date).toISOString(),
        })
          .then((result) => {
            Swal.close();
            toast.success(result.message, toastOptions);
            setTimeout(() => {
              window.open(result.link);
            }, 3000);
          })
          .catch((err) => {
            Swal.close();
            toast.error(err.response.data.message);
          });

        break;
      case "delete_user":
        await deleteUser(userData.id)
          .then(async () => {
            Swal.close();
            toast.success("User deleted successfully");
          })
          .catch((err) => {
            Swal.close();
            toast.error(err.response.data.message);
          });
        break;
      case "update_membership_cancellation_active_reminder_admin":
        await updateMembershipCancellationActiveReminderAdminCall({
          active_reminder_process: false,
          token: userData?.membershipCancellationToken,
        })
          .then(() => {
            Swal.close();
            toast.success("Membership cancellation updated successfully");
          })
          .catch((err) => {
            Swal.close();
            toast.error(err.response.data.message);
          });
        break;
      case "update_user":
        let updatedData = modifiedData;
        if ("phoneNumber" in modifiedData || "countryCode" in modifiedData) {
          // Ensure both phoneNumber and countryCode are included in the update
           updatedData = {
            ...modifiedData,
            phoneNumber: modifiedData.phoneNumber || userData.phoneNumber,
            countryCode: modifiedData.countryCode || userData.countryCode
          };
        }
        await  updateUser(updatedData)
          .then(() => {
            Swal.close();
            toast.success("User updated successfully");
          })
          .catch((err) => {
            Swal.close();
            toast.error(err.response.data.message);
          });
        break;
      case "whitelist_user":
        await whitelistUser(userData.id)
          .then(async () => {
            Swal.close();
            toast.success("User whitelisted successfully");
          })
          .catch((err) => {
            Swal.close();
            toast.error(err.response.data.message);
          });
        break;
      default:
        break;
    }
    setTimeout(() => {
      window.location.reload();
    }, 4000);
  };

  const startLoading = () => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: true,
      allowEscapeKey: false,
      showConfirmButton: false,
      icon: "info",
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
  };

  return (
    <>
      <span data-toggle="modal" data-target={`#${id}`}>
        {ModalTrigger}
      </span>
      <div
        className="modal fade"
        id={id}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ width: contentWidth }}>
            {withHeader === true && (
              <>
                <div className="modal-header">
                  <h5
                    className="modal-title"
                    style={{ color: "#F9629F" }}
                    id="exampleModalLongTitle"
                  >
                    {ModalTitle}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </>
            )}

            <div className="modal-body" style={{ color: "black" }}>
              {ModalBody}
            </div>

            <div className="modal-footer">
              {onlyOneButton ? (
                <button
                  type="button"
                  className={buttonConfig.saveButton.style}
                  data-dismiss="modal"
                >
                  {buttonConfig.saveButton.text}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className={buttonConfig.cancelButton.style}
                    data-dismiss="modal"
                    disabled={disabled}
                    onClick={() => handleSubmit()}
                  >
                    {buttonConfig.cancelButton.text}
                  </button>
                  <button
                    type="button"
                    className={buttonConfig.saveButton.style}
                    data-dismiss="modal"
                  >
                    {buttonConfig.saveButton.text}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
